import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { RestService } from './lib/RestService';
import { setQueryParams } from './lib/helpers';

export class Promo {
  id: number;
  date: string;
  slug: string;
  link: string;
  title: {
    rendered: string;
  };
  content: {
    rendered: string;
  };
  excerpt: {
    rendered: string;
  };
  categories: number[];
  tags: {
    id: number;
    name: string;
    slug: string;
    url: string;
  }[];
  featured_media_url: string;
}

@Injectable()
export class PromoService extends RestService {

  private apiUrl = `${environment.wpApiUrl}posts`;

  constructor(private http: HttpClient) {
    super();
  }

  public get(tags?: string[]): Promise<Promo[] | any> {
    const options = {categories: '13', 'per_page': '100'};
    if (tags && tags.length > 0) options['filter[tag]'] = tags.join(',');
    const apiUrl = setQueryParams(this.apiUrl, options);
    return this.http.get<Promo[]>(apiUrl)
      .toPromise()
      .catch(this.handleError);
  }
}
